import { CommonModule, isPlatformBrowser, NgClass, NgFor, NgIf, NgSwitch } from "@angular/common";
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, ElementRef, Inject, Input, makeStateKey, NgZone, OnInit, PLATFORM_ID, signal, TransferState, ViewChild } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { RouterLink } from "@angular/router";
import { DeviceService } from "@src/app/servicios/device/device.service";
import { FooterService } from "@src/app/servicios/footer.service";
import { GoogleAnalyticsService } from "ngx-google-analytics";
import { first } from "rxjs";
import { ConfigService } from "src/app/servicios/config/config.service";
import { PlatformService } from "src/app/servicios/platform/platform.service";
import { KebabCasePipe } from "../../../pipes/kebab-case.pipe";
import { SafeResourceUrlPipe } from "../../../pipes/safeResourceUrl/safe-resource-url.pipe";
import { NoticiasService } from "../../../servicios/noticias/noticias.service";
import { BannerAppMvComponent } from "../../banner-app-mv/banner-app-mv.component";
import { BloqueCartaDirectorComponent } from "../../bloques-filas/bloque-carta-director/bloque-carta-director.component";
import { BloquePatrocinadosComponent } from "../../bloques-filas/bloque-patrocinados/bloque-patrocinados.component";
import { BloqueUltimosBlogsComponent } from "../../bloques-filas/bloque-ultimos-blogs/bloque-ultimos-blogs.component";
import { BloqueSeparadorComponent } from "../../bloques-filas/bloque-separador/bloque-separador.component";
import { DosColumnasMultifilasComponent } from "../../bloques-filas/dos-columnas-multifilas/dos-columnas-multifilas.component";
import { FilaCuatroColumnasComponent } from "../../bloques-filas/fila-cuatro-columnas/fila-cuatro-columnas.component";
import { FilaDosColumnasComponent } from "../../bloques-filas/fila-dos-columnas/fila-dos-columnas.component";
import { FilaTresColumnasComponent } from "../../bloques-filas/fila-tres-columnas/fila-tres-columnas.component";
import { FilaUnaColumnaComponent } from "../../bloques-filas/fila-una-columna/fila-una-columna.component";
const TRANSFER_KEY = makeStateKey<any>("transferState");

@Component({
  selector: "app-estructura-defecto",
  templateUrl: "./estructura-defecto.component.html",
  styleUrls: ["./estructura-defecto.component.css"],
  imports: [NgFor, NgSwitch, NgIf, NgClass, CommonModule, MatButtonModule, FilaUnaColumnaComponent, RouterLink, BloqueCartaDirectorComponent, FilaDosColumnasComponent, FilaTresColumnasComponent, FilaCuatroColumnasComponent, DosColumnasMultifilasComponent, BannerAppMvComponent, BloqueUltimosBlogsComponent, BloquePatrocinadosComponent, BloqueSeparadorComponent, KebabCasePipe, SafeResourceUrlPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EstructuraDefectoComponent implements OnInit, AfterViewInit {
  @Input() videosDirecto = [];
  @Input() publicidadCabecera;
  @Input() publicidadTop;
  @Input() publicidadBloques;
  @Input() publicidadDivisoresMovil;
  estructuraNoticias = signal([]);
  constantesGlobales;
  numTotalDivisores = 3;
  saltarPubliVideo = signal(false);
  hidePubliVideo = signal(false);
  lcpBlocks = signal<number[]>([0]);
  videoPublicidad;
  isWebView = signal(false);
  autorEmpresa = signal("");
  isMobile = signal(null);
  isDeviceMobile: boolean | undefined = undefined;
  current_page: number = 1;
  page_limit: number = 5;
  page_data = [];
  totalPages: any;

  // Muestra las fechas de publicacion en las noticias de portada.
  showLadingDates: boolean = false;

  @ViewChild("sentinel", { static: false }) sentinel: ElementRef;
  private intersectionObserver: IntersectionObserver;
  constructor(
    private readonly noticiasService: NoticiasService,
    private readonly configService: ConfigService,
    private readonly platformService: PlatformService,
    @Inject(PLATFORM_ID) private readonly platformId,
    private readonly ngZone: NgZone,
    private readonly transferState: TransferState,
    private readonly deviceService: DeviceService,
    private readonly cdr: ChangeDetectorRef,
    private gaService: GoogleAnalyticsService,
    private readonly footerService: FooterService,
  ) {
    effect(() => {
      this.isDeviceMobile = deviceService.deviceIsMobile();
    });
  }

  ngOnInit(): void {
    this.footerService.isPaginationFinished.set(false);
    this.deviceService.isMobile().subscribe((isMobile) => {
      this.isMobile.set(isMobile);
    });
    this.constantesGlobales = this.configService.getConstantesGlobales();
    const configPrensa = this.configService.getConfigPrensa();
    if (configPrensa) {
      configPrensa.pipe(first()).subscribe((resultConfig) => {
        if (resultConfig) {
          const configBloque = resultConfig.general["app-home"];
          this.autorEmpresa.set(configBloque?.autor_empresa);
        }
      });
    }
    this.isWebView.set(this.isInAndroidWebView() || this.isInIOSWebView());
    this.getEstructuraNoticias();
    this.initPublicidadVideo();
  }

  ngAfterViewInit(): void {
    // Solo se ejecuta en el navegador
    if (isPlatformBrowser(this.platformId) && this.sentinel) {
      this.intersectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && this.current_page < this.totalPages) {
              // Carga la siguiente página cuando el sentinel es visible
              this.fetchNextPage();
            }
          });
        },
        {
          rootMargin: "360px", // margen para disparar la carga antes de llegar al final
        },
      );

      this.intersectionObserver.observe(this.sentinel.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
    }
  }
  getEstructuraNoticias() {
    if (!this.platformService.isBrowser()) {
      this.fetchBlogsAndStoreKey(1);
    } else if (this.transferState.hasKey(TRANSFER_KEY)) {
      const transferData = this.transferState.get<any>(TRANSFER_KEY, null);
      this.setEstructura(transferData);
    } else {
      this.fetchBlogsAndStoreKey(1);
    }
  }

  setPage(page: number) {
    this.current_page = page;
    this.page_data = this.estructuraNoticias();
    // Envía evento a Google Analytics para el refresco de anuncios tras cargar más noticias
    this.gaService.event("adRefresh");
    if (this.current_page == this.totalPages) {
      this.footerService.isPaginationFinished.set(true);
    }
    this.cdr.detectChanges();
  }

  fetchBlogsAndStoreKey(page: number = 1) {
    const selectedNews = this.noticiasService.getNoticiasFijadas(this.constantesGlobales.idAmbito, page, this.page_limit);
    if (selectedNews) {
      selectedNews.pipe(first()).subscribe((result) => {
        if (!Array.isArray(result)) {
          this.page_limit = result.pageLimit;
          this.current_page = parseInt(result.pageNumber, 10);
          this.totalPages = result.totalPages;

          // Convertimos las entradas numéricas en un array
          result = Object.keys(result)
            .filter((key) => /^\d+$/.test(key))
            .map((key) => result[key]);
        } else {
          // Si ya es un array, se asigna la página actual.
          this.current_page = page;
        }

        // Aplicamos la transformación a cada noticia
        let contadorPubli = 0;
        if (page > 1) {
          const currentData = this.estructuraNoticias();
          const lastDivisor = currentData.filter((noticia) => noticia.tipoBloque === "bloque-divisor-publi").pop(); // Obtiene el último divisor
          contadorPubli = lastDivisor ? lastDivisor.publiNumber : 0;
        }
        const resultCounterPubli = result.map((noticia) => {
          if (noticia.tipoBloque === "bloque-separador") {
            const esObjeto = typeof noticia.data === "object" && noticia.data !== null;
            if (!esObjeto) {
              noticia.data = JSON.parse(noticia.data);
            }
          }
          if (noticia.tipoBloque === "bloque-divisor-publi") {
            contadorPubli++;
            return { ...noticia, publiNumber: contadorPubli };
          }
          return noticia;
        });

        // Si es la primera página, se establece la data;
        // si no, se acumula la nueva data a la ya existente.
        if (page === 1) {
          this.estructuraNoticias.set(resultCounterPubli);
          if (this.isMobile()) this.lcpBlocks.set([0]);
          else this.calculateLCP(result);
          // Guardamos el estado transferido (opcional, para SSR)
          this.transferState.set(TRANSFER_KEY, {
            result: resultCounterPubli,
            lcpBlocks: this.lcpBlocks(),
            pageLimit: this.page_limit,
            pageNumber: this.current_page,
            totalPages: this.totalPages,
          });
        } else {
          const currentData = this.estructuraNoticias();
          this.estructuraNoticias.set(currentData.concat(resultCounterPubli));
        }

        // Actualiza la vista: muestra todos los items acumulados hasta la página actual.
        this.setPage(page);
      });
    }
  }

  fetchNextPage() {
    const nextPage = this.current_page + 1;
    if (nextPage <= this.totalPages) {
      this.fetchBlogsAndStoreKey(nextPage);
    }
  }

  setEstructura(data) {
    this.estructuraNoticias.set(data.result);
    this.page_limit = data.pageLimit;
    this.current_page = parseInt(data.pageNumber, 10);
    this.totalPages = data.totalPages;
    if (this.isMobile()) {
      this.lcpBlocks.set([0]);
    } else {
      this.lcpBlocks.set(data.lcpBlocks);
    }
    this.setPage(1);
  }

  isInAndroidWebView(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /; wv/.test(userAgent);
    }
  }

  isInIOSWebView(): boolean {
    if (isPlatformBrowser(this.platformId)) {
      const userAgent = window.navigator.userAgent.toLowerCase();

      const isIOS = /iphone|ipod|ipad/.test(userAgent);
      const notSafari = !/safari/.test(userAgent);
      const notStandalone = !("standalone" in window.navigator && window.navigator["standalone"]);

      return isIOS && notSafari && notStandalone;
    }
  }
  getExtraClass(bloque): string {
    switch (bloque) {
      case "fila-una-columna":
        return "columns-1";
      case "fila-dos-columnas":
        return "columns-2";
      case "fila-tres-columnas":
        return "columns-3";
      case "fila-cuatro-columnas":
        return "columns-4";
      case "dos-columnas-multifilas":
        return "columns-2";
      default:
        return "";
    }
  }

  initPublicidadVideo(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.videoPublicidad = document.getElementById("adVideo") as HTMLVideoElement;
      // this.videoPublicidad.focus();
      // this.videoPublicidad.play();
      this.ngZone.runOutsideAngular(() => {
        const interval = setInterval(() => {
          this.saltarPubliVideo.set(true);
          clearInterval(interval);
        }, 5000);
      });
    }
  }

  closeAdsVideo(video): void {
    video.pause();
    this.hidePubliVideo.set(true);
  }

  abrirEnlace = (enlaceElement) => {
    if (isPlatformBrowser(this.platformId)) {
      const enlace = enlaceElement.getAttribute("href");
      window.open(enlace, "_blank");
    }
  };

  /**
   * Hace el cálculo de los bloques que se son candidatos a ser el LCP (Largest Contentful Paint), esto se hace
   * en base a la cantidad de noticias que se muestran en cada bloque y se le asigna un peso a cada tipo de bloque.
   * El resultado es un array con los índices de los bloques que se consideran como LCP, almacenado en 'lcpBlocks'.
   * @param blocks - Bloques de noticias.
   */
  calculateLCP(blocks) {
    let mobile = false;
    if (this.platformService.isBrowser()) {
      mobile = window.innerWidth <= 768;
    }
    if (mobile) {
      this.lcpBlocks.set([0]);
      return;
    }
    const blockTypes = {
      "fila-una-columna": {
        weight: 4,
        newsNumber: 1,
      },
      "fila-dos-columnas": {
        weight: 3,
        newsNumber: 2,
      },
      "fila-tres-columnas": {
        weight: 2,
        newsNumber: 3,
      },
      "fila-cuatro-columnas": {
        weight: 1,
        newsNumber: 4,
      },
    };

    if (!blocks.length) {
      return;
    }
    const blockNumber = blocks.length > 3 ? blocks.slice(0, 3) : blocks.slice(0, blocks.length);

    const blocksWithIndex = blockNumber.map((block, index) => ({
      ...block,
      originalIndex: index,
    }));
    const weightedArray = blocksWithIndex.sort((a, b) => blockTypes[b.tipoBloque].weight - blockTypes[a.tipoBloque].weight);

    const lcpBlocks = [];
    let newsTotal = 0;
    for (const block of weightedArray) {
      newsTotal += blockTypes[block.tipoBloque].newsNumber;
      if (newsTotal >= 4) break;
      lcpBlocks.push(block.originalIndex);
    }

    this.lcpBlocks.set(lcpBlocks);
  }
}
